import { render, staticRenderFns } from "./movement.vue?vue&type=template&id=2ee6bb42&scoped=true"
import script from "./movement.vue?vue&type=script&lang=js"
export * from "./movement.vue?vue&type=script&lang=js"
import style0 from "./movement.vue?vue&type=style&index=0&id=2ee6bb42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee6bb42",
  null
  
)

export default component.exports